import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { orange, blue, red } from '@material-ui/core/colors';
import Zoom from '@material-ui/core/Zoom';
import Fade from '@material-ui/core/Fade';

const styles = (theme) => ({
	root: {
		display: 'flex',
		marginBottom: theme.spacing.unit * 4,
		marginLeft: theme.spacing.unit * 4,
		marginRight: theme.spacing.unit * 4,
		transition: 'background-color 500ms linear',
		'&:first-child': {
			marginTop: theme.spacing.unit * 4
		},
		'&:last-child': {
			marginBottom: 0
		}
	},
	text: {
		display: 'flex',
		alignItems: 'center',
		paddingRight: theme.spacing.unit * 3,
		paddingLeft: theme.spacing.unit * 3,
		borderRadius: theme.spacing.unit,
		cursor: 'default',

	},
	mark: {
		height: 40,
		width: 50,
		minWidth: 50,
		textAlign: 'center',
		lineHeight: '40px',
		fontSize: 29,
		color: 'white'
	},
	selected: {
		color: 'white',
		backgroundColor: orange.A400
	},
	correct: {
		color: 'white',
		backgroundColor: blue[400]
	},
	incorrect: {
		color: 'white',
		backgroundColor: red[400]
	},
	correctMark: {
		color: blue[400]
	},
	incorrectMark: {
		color: red[400]
	},
	dotContainer: {
		height: 40,
		width: 50,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	dot: {
		height: 8,
		width: 8,
	}
});

class Answer extends Component {
	renderMark() {
		const { correct, classes } = this.props;

		if (correct) {
			return <i className={classNames(classes.mark, classes.correctMark, 'fa', 'fas fa-check')} />;
		}
		return <i className={classNames(classes.mark, classes.incorrectMark, 'fa', 'fas fa-times')} />;
	}

	render() {
		const { classes, selected, marked, textHighlighted, text, questionAnswered, correct, visible, index } = this.props;
		const textClasses = [classes.text];

		if (selected) {
			textClasses.push(classes.selected);
		} else if (marked || textHighlighted) {
			if (correct) {
				textClasses.push(classes.correct);
			} else {
				textClasses.push(classes.incorrect);
			}
		}

		const content = (
			<Fragment>
				{
					marked ?
						<Zoom in={marked} timeout={500}>
							<div className={classes.mark}>
								{this.renderMark()}
							</div>
						</Zoom> :
						<div className={classes.dotContainer}><div className={classNames('theme-background', classes.dot)} /></div>
				}
				<Typography variant="title" className={classNames(textClasses)} color={selected ? 'inherit' : 'default'}>
					{text}
				</Typography>
			</Fragment>
		);

		if (questionAnswered) {
			return <div className={classes.root}>{content}</div>;
		}

		return (
			<Fade in={visible} timeout={500} style={{ transitionDelay: 300 + (index * 200) }}>
				<div className={classes.root}>
					{content}
				</div>
			</Fade>
		);
	}
}

Answer.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	correct: PropTypes.bool.isRequired,
	visible: PropTypes.bool.isRequired,
	selected: PropTypes.bool,
	marked: PropTypes.bool,
	textHighlighted: PropTypes.bool,
	itemIndex: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
	questionAnswered: PropTypes.bool.isRequired,
	index: PropTypes.number.isRequired,
};

Answer.defaultProps = {
	selected: false,
	marked: false,
	textHighlighted: false,
};

function mapStateToProps({ exercise, loader: { testMode, testSent } }, ownProps) {
	const selected = exercise.answersSelected[ownProps.itemIndex] === ownProps.index;
	const marked = exercise.answersMarked[ownProps.itemIndex] && exercise.answersMarked[ownProps.itemIndex][ownProps.index];
	return {
		textHighlighted:
			(!testMode && marked) ||
			(testSent && ownProps.correct),
		marked: (!testMode || testSent) && selected,
		selected: testMode && !testSent && selected,
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Answer);
